import React, { Children, Component } from "react";
import { func, node, string } from "prop-types";
import classNames from "classnames";

class ProductFilters extends Component {
    static propTypes = {
        moreFilters: node,
        children: node.isRequired,
        handleResetDateFilters: func.isRequired,
        className: string,
    };

    static defaultProps = {
        moreFilters: null,
    };

    handleMoreFiltersClick = () => {
        const { handleResetDateFilters } = this.props;
        handleResetDateFilters(false);
    };

    render() {
        const { children, moreFilters, className } = this.props;

        return (
            <div className={classNames(className, "filters-toolbar")}>
                <div className="filter-buttons">{children && Children.map(children, (child) => child)}</div>
                <div className="filter-fields">{moreFilters}</div>
            </div>
        );
    }
}

export default ProductFilters;
